import { createFileRoute, Outlet } from "@tanstack/react-router";

// Bàn làm việc QC (QĐ 0521): trang gom việc theo loại QC + hai trang con.
export const Route = createFileRoute("/_app/qc-desk")({
  component: () => <Outlet />,
});
